import { createAction, props } from '@ngrx/store';
import {
  SettingsServiceLoadResponseJson,
  SettingsServicePersistDropboxRequestJson,
  SettingsServicePersistProjectPermitRequestJson,
  SettingsServicePersistProjectSurveyRequestJson,
} from '@vmspdb/definitions';
import { SettingsFilters } from './settings-filters';

export const syncSearch = createAction(
  '[Settings] Sync Search',
  props<{ nonce: string; reset?: boolean }>(),
);

export const loadSettings = createAction('[Settings] Load Settings');

export const loadSettingsSuccess = createAction(
  '[Settings] Load Settings Success',
  props<{ settings: SettingsServiceLoadResponseJson }>(),
);

export const loadSettingsFailure = createAction(
  '[Settings] Load Settings Failure',
  props<{ error: any }>(),
);

export const saveDropboxSettings = createAction(
  '[Settings] SaveDropbox Settings',
  props<{ settings: SettingsServicePersistDropboxRequestJson }>(),
);

export const saveDropboxSettingsFailure = createAction(
  '[Settings] SaveDropbox Settings Failure',
  props<{ error: any }>(),
);

export const saveProjectPermitSettings = createAction(
  '[Settings] SaveProjectPermit Settings',
  props<{
    settings: SettingsServicePersistProjectPermitRequestJson;
  }>(),
);

export const saveProjectPermitSettingsFailure = createAction(
  '[Settings] SaveProjectPermit Settings Failure',
  props<{ error: any }>(),
);

export const saveProjectSurveySettings = createAction(
  '[Settings] SaveProjectSurvey Settings',
  props<{
    settings: SettingsServicePersistProjectSurveyRequestJson;
  }>(),
);

export const saveProjectSurveySettingsFailure = createAction(
  '[Settings] SaveProjectSurvey Settings Failure',
  props<{ error: any }>(),
);

export const updateFilterSettings = createAction(
  '[Settings] Update Filter Settings',
  props<{ filters: Partial<SettingsFilters> }>(),
);
